<admin-app-header></admin-app-header>

<div class="container-fluid admin-page">
    <div class="row header">
        <div class="col-8">
            <h2 class="mb-2">Test Local Functions</h2>
            <p class="text-muted">Run test callable functions against the local emulator</p>
        </div>
        <div class="col-4" *ngIf="isEmulator">
            <div class="form-group mt-2">
                <select [(ngModel)]="selectedCategory" class="form-control form-select">
                    <option *ngFor="let category of categories" [value]="category">
                        {{ category }}
                    </option>
                </select>
            </div>
        </div>
    </div>

    <ng-container *ngIf="!isEmulator">
        <div class="row">
            <div class="col-12">
                <div class="alert alert-danger d-flex align-items-center">
                    <i class="fas fa-exclamation-triangle fa-2x me-3"></i>
                    <div>
                        <h5 class="mb-1">Not Available</h5>
                        <p class="mb-0">This page is only available in the local emulator environment. These functions can cause data changes and should never be run against production.</p>
                    </div>
                </div>
            </div>
        </div>
    </ng-container>

    <ng-container *ngIf="isEmulator">
        <div class="row">
            <div class="col-12">
                <div class="alert alert-warning mb-4">
                    <i class="fas fa-flask me-2"></i>
                    <strong>Emulator Mode:</strong> These functions will execute against your local Firebase emulator. They trigger cron jobs, send emails, and perform data operations.
                </div>
            </div>
        </div>

        <div class="row">
            <div class="col-12">
                <div class="card">
                    <div class="card-body p-0">
                        <div class="table-responsive">
                            <table class="table table-hover mb-0">
                                <thead class="table-light">
                                    <tr>
                                        <th style="width: 30px">
                                            <i class="fas fa-tag"></i>
                                        </th>
                                        <th>Function Name</th>
                                        <th>Description</th>
                                        <th style="width: 120px">Category</th>
                                        <th style="width: 100px">Frequency</th>
                                        <th style="width: 250px">Schedule</th>
                                        <th style="width: 120px; text-align: center">Action</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr *ngFor="let fn of filteredFunctions">
                                        <td class="text-center">
                                            <i class="fas {{ getCategoryIcon(fn.category) }} text-muted"></i>
                                        </td>
                                        <td>
                                            <strong>{{ fn.name }}</strong>
                                            <br />
                                            <code class="small text-muted">{{ fn.endpoint }}</code>
                                        </td>
                                        <td class="text-muted small">{{ fn.description }}</td>
                                        <td>
                                            <span class="badge bg-secondary">{{ fn.category }}</span>
                                        </td>
                                        <td>
                                            <span
                                                class="badge"
                                                [ngClass]="{
                                                    'bg-success': fn.frequency === 'Daily',
                                                    'bg-primary': fn.frequency === 'Weekly' || fn.frequency === 'Monthly',
                                                    'bg-info': fn.frequency === 'Hourly',
                                                    'bg-secondary': fn.frequency === 'Manual'
                                                }"
                                            >
                                                {{ fn.frequency }}
                                            </span>
                                        </td>
                                        <td class="small text-muted">
                                            <i class="fas fa-clock me-1"></i>
                                            {{ fn.schedule }}
                                        </td>
                                        <td class="text-center">
                                            <button
                                                (click)="runFunction(fn)"
                                                [disabled]="fn.isRunning"
                                                class="btn btn-primary btn-sm"
                                            >
                                                <span *ngIf="fn.isRunning" class="spinner-border spinner-border-sm me-1" role="status" aria-hidden="true"></span>
                                                <i *ngIf="!fn.isRunning" class="fas fa-play me-1"></i>
                                                {{ fn.isRunning ? 'Running...' : 'Run' }}
                                            </button>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </ng-container>
</div>
